<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.expenses') }}
            <template v-if="ready">
              >
              {{ expense.ex_code }}
            </template>
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="ready"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
            <div
              class="dropdown nodro item">
              <button
                class="btn no-bg text-secondary"
                type="button"
                @click="openCloneModal()">
                <i class="fas fa-copy"/>
                <span class="name">{{ $t('button.clone') }}</span>
              </button>
            </div>
            <!-- status -->
            <template>
              <!-- status button -->
              <div
                v-if="expense.status == 'padding' && hasRoleApprove"
                class="dropdown item">
                <button
                  class="btn no-bg dropdown-toggle text-warning"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  <span class="name">{{ $t('status.ex.padding') }}</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    v-if="expense.status == 'padding'"
                    class="dropdown-item"
                    @click="updateExpenseStatus({ex_id: expense.ex_id, status: 'approved'})">
                    <i
                      class="far fa-check-circle text-info"
                      style="position: relative; left: -7px;"/>
                    <span class="text-info">{{ $t('status.ex.approve') }}</span>
                  </a>
                  <a
                    v-if="expense.status == 'padding'"
                    class="dropdown-item"
                    @click="updateExpenseStatus({ex_id: expense.ex_id, status: 'rejected'})">
                    <i
                      class="far fa-times-circle text-danger"
                      style="position: relative; left: -7px;"/>
                    <span class="text-danger">{{ $t('status.ex.reject') }}</span>
                  </a>
                </div>
              </div>
              <!-- status message -->
              <div
                v-else
                class="dropdown nodro item">
                <template>
                  <span
                    v-if="getExpenseStatus(expense, $t, mixin).status == 'padding'"
                    class="text-warning">
                    {{ getExpenseStatus(expense, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getExpenseStatus(expense, $t, mixin).status == 'completed'"
                    class="text-success">
                    {{ getExpenseStatus(expense, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getExpenseStatus(expense, $t, mixin).status == 'uncompleted'"
                    class="text-info">
                    {{ getExpenseStatus(expense, $t, mixin).message }}
                  </span>
                  <span
                    v-else
                    class="text-danger">
                    {{ getExpenseStatus(expense, $t, mixin).message }}
                  </span>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <WrapperDoc>
          <template #form>
            <section>
              <div class="col-md-12 no-padding">
                <section-header
                  :title="$t('message.vendor')"
                  :subtitle="$t('series.ex') + ' ' + expense.ex_code"
                />
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.storecompanyperson') }}</label>
                        <selectize
                          v-model="form.pickedVendorId"
                          :default="form.defaultVendorId"
                          :updateoption="form.updateOptionVendor"
                          :options="form.optionVendors"
                          :multiple="false"
                          :create="true"
                          :loading="form.loadingVendor"
                          :placeholder="$t('placeholder.selectorcreate')"
                          :disabled="disabledForm"
                          @add="onAddedVendor" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="form.pickedVendorId"
                  class="form-row">
                  <div class="col-md-6">
                    <div
                      class="form-group row"
                      style="height: 100%;">
                      <div class="col-md-12">
                        <label>{{ $t('message.address') }}</label>
                        <textarea
                          v-model="form.vendor.address"
                          :disabled="disabledForm"
                          class="form-control"
                          style="height: calc(100% - 37px);"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.tel') }}</label>
                        <input
                          v-model="form.vendor.tel"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.email') }}</label>
                        <input
                          v-model="form.vendor.email"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.taxpayerno') }}</label>
                        <input
                          v-model="form.vendor.tax_id"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div class="col-md-12 no-padding">
                <section-header
                  :title="$t('message.infopayment')"
                />
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.expclaimtype') }}</label>
                        <selectize
                          v-model="form.pickedDescription"
                          :default="form.defaultDescription"
                          :options="form.optionDescriptions"
                          :validation="form.trickDescriptionValidation"
                          :multiple="false"
                          :create="true"
                          :disabled="disabledForm"
                          :placeholder="$t('placeholder.selectorcreate')" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('apps.expenses.message.expensetype') }}</label>
                        <BaseDropdown
                          v-model="form.expense_type"
                          :options="expenseOptions"
                          :disabled="disabledForm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.date') }}</label>
                        <BaseInputDatePicker
                          v-model="form.created_at"
                          :disabled="disabledForm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.paidamount', {string: currency}) }}</label>
                        <input
                          v-model="form.payment_amount"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control text-select-all"
                          @keypress="numberOnly"
                          @keyup="form.payment_amount = setToValidNumber(form.payment_amount)"
                          @blur="form.payment_amount = setToCustomDigitsNumber(form.payment_amount)">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.taxes') }}</label>
                        <MultipleSelect
                          v-model="form.taxIds"
                          :options="taxOptions"
                          :disabled="disabledForm"
                          :multiple="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row mt-2">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col">
                        <b-form-textarea
                          :placeholder="$t('placeholder.note')"
                          v-model="form.note"
                          :disabled="disabledForm"
                          style="min-height: 126px;"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="col-md-12 row no-padding no-margin">
                      <div
                        v-if="taxResults.length > 0"
                        class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.untaxed') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.untaxed) }}
                        </div>
                      </div>
                      <div
                        v-for="(tax, index) in taxResults"
                        :key="index"
                        class="col-12 row no-margin no-padding"
                      >
                        <div class="col-6 no-padding mb-2">
                          {{ tax.displayText }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(tax.total) }}
                        </div>
                      </div>
                      <div
                        v-if="taxResults.length > 0 && total.payment != total.grand && total.payment != total.untaxed"
                        class="col-12 row no-margin mb-2 no-padding">
                        <div class="col-6 no-padding">
                          {{ $t('message.totalamount') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.payment) }}
                        </div>
                      </div>
                      <div class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding">
                          {{ $t('message.netpayable') }}
                        </div>
                        <div class="col-6 no-padding text-right">
                          <span class="text-underline-border">
                            {{ getNumber(total.grand) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              v-if="!disabledForm"
              class="action-bar"
            >
              <template>
                <div
                  v-if="!$store.state.app.loading"
                  class="col-md-12 text-right">
                  <button
                    class="btn btn-web"
                    @click="update()">{{ $t('button.save') }}</button>
                </div>
                <div
                  v-else
                  class="col-md-12 text-right">
                  <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
                  <button
                    class="btn btn-web btn-block-mobile-only"
                    disabled><i class="fas fa-spinner spin"/></button>
                </div>
              </template>
            </section>
          </template>
          <template #ref>
            <DocRef
              :refDoc="`exp`"
              :refId="expense.ex_id"
              :refCode="expense.ex_code"
              :showLog="getExpenseSetting.log_topic.is_active"
              :showAttachFile="getExpenseSetting.attach_file.is_active"
              :logTopics="getExpenseSetting.log_topic.options"
              :isSubmitted="isSubmitted"
            >
              <RefEXP
                :expense="expense"
                :disabled="!hasRoleCreate"
              />
            </DocRef>
          </template>
        </WrapperDoc>
      </template>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog"
        role="document">
        <div
          v-if="ready"
          class="modal-content">
          <div
            :class="[{'no-border-bottom': expense.reference.payments.length == 0}]"
            class="modal-header">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="expense.reference.payments.length > 0"
            class="modal-body">
            <p class="text-danger">
              <strong>{{ $t('message.refdocswillbedeleted') }}</strong>
            </p>
            <div v-if="expense.reference.payments.length > 0">
              <p class="m-0">
                <strong>{{ $t('documents.pe') }} ({{ expense.reference.payments.length }})</strong>
              </p>
              <ul>
                <li
                  v-for="(payment, index) in expense.reference.payments"
                  :key="index">
                  <router-link-custom
                    :to="{name: 'AccountsPaymentEntryEdit', query: {
                      pe_id: payment.pe_id,
                      pe_code: payment.pe_code
                    }}"
                    :text="payment.pe_code"
                    :status="{
                      text: getPaymentStatus(payment, $t).message,
                      color: getColorFormStatus(getPaymentStatus(payment, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="12"
                    :current_appid="4"/>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

    <BaseConfirmCloneModal
      :show="modalConfirmClone.show"
      :loading="modalConfirmClone.loading"
      @onClose="handleCloseCloneModal"
      @onCancel="handleCancleCloneModal"
      @onConfirm="handleConfirmCloneModal({
        payload: payloadClone,
        createApiFn: insertExpense,
        redirectTo: 'ExpensesClaimAll',
        refCode: 'expense.ex_code',
      })"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import WrapperDoc from '@/components/combine/WrapperDoc.vue'
import DocRef from '@/components/combine/DocRef.vue'
import RefEXP from '@/components/apps/expenses/ex/include/RefEXP.vue'
import BaseConfirmCloneModal from '@/components/base/BaseConfirmCloneModal'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import confirmCloneMixin from '@/mixins/confirmClone'
import { getDisplayTaxNameRate, getMasterDataText } from '../../../../helpers'
import MultipleSelect from '@/components/custom/MultipleSelect'

export default {
  components: {
    WrapperDoc,
    DocRef,
    RefEXP,
    BaseConfirmCloneModal,
    MultipleSelect,
  },
  mixins: [discardFormMixin, userPermissionMixin, confirmCloneMixin],
  data () {
    return {
      ready: false,

      form: {
        pickedVendorId: null,
        defaultVendorId: null,
        optionVendors: [],
        updateOptionVendor: null,
        loadingVendor: false,
        vendor: {
          address: null,
          tax_id: null,
          email: null,
          tel: null,
        },

        pickedDescription: null,
        defaultDescription: null,
        optionDescriptions: [],
        trickDescriptionValidation: 0,
        created_at: null,
        paid_by: 'shop',
        payment_amount: 0,
        note: '',
        expense_type: null,
        taxIds: [],
      },

      originalForm: null,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      isSubmitted: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      currency: 'getCurrency',
      dateformat: 'getDateFormat',
      descriptionLists: 'getExpenseDescriptionLists',
      expense: 'getExpense',
      getExpenseStatus: 'getExpenseStatus',
      getPaymentStatus: 'getPaymentStatus',
      getExpenseSetting: 'getExpenseSetting',
      expenseSetting: 'getExpenseSetting',
      taxes: 'getTaxes',
      vendors: 'getVendors',
      getVendorById: 'getVendorById',
      getPartnerContact: 'getPartnerContact',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
    }),
    expenseTypes() {
      if (this.expenseSetting && this.expenseSetting.types) {
        return this.expenseSetting.types
      }
      return []
    },
    expenseOptions() {
      return this.expenseTypes
        .filter((type) => type.is_active)
        .map((type) => {
          return {
            text: getMasterDataText(type.name, this.$t),
            value: type.name,
          }
        })
    },
    defaultExpenseType() {
      return this.expenseTypes.find((type) => type.is_default).name
    },
    disabledForm () {
      return [
        'approved',
        'rejected',
      ].includes(this.expense.status) || !this.hasRoleEdit
    },
    payloadClone() {
      const fakeOrders = [
        {
          price: this.expense.payment.price,
          taxes: this.expense.taxes.reduce((acc, cur) => {
            const curTax = cur
            const tax = this.taxes.find((tax) => tax.tax_id == curTax.tax_id)
            if (tax) {
              acc.push(tax)
            }
            return acc
          }, []),
        },
      ]
      const orders = this.getDataSetOrders(fakeOrders)
      const total = this.getTotal(orders)
      const taxes = orders[0].taxes
      const vendorInfo = this.getVendorById(this.expense.ven_id)

      const dataSet = {
        'status': 'padding',
        'description': this.expense.description,
        'expense_type': this.expense.expense_type,
        'created_at': this.expense.created_at,
        'paid_by': this.expense.paid_by,
        'payment': {
          'price': this.expense.payment.price,
          'sub': this.expense.payment.sub,
          'tax': this.expense.payment.tax,
          'total': this.expense.payment.total,
          'amount': this.expense.payment.amount,
        },
        'note': this.expense.note,
        'vendor_id': this.expense.ven_id,
        'taxes': taxes,
        'report': {
          'sub_total': total.untaxed,
          'tax_total': total.taxes.all,
          'grand_total': total.grand,
          'category_id': null,
          'category_name': this.expense.expense_type,
          'vendor_id': this.expense.ven_id,
          'vendor_name': vendorInfo ? vendorInfo.vendor_name : null,
        },
      }
      return dataSet
    },
    selectedTaxes() {
      return this.form.taxIds.reduce((acc, cur) => {
        const taxId = cur
        const tax = this.taxes.find((tax) => tax.tax_id == taxId)
        if (tax) {
          acc.push(tax)
        }
        return acc
      }, [])
    },
    taxOptions() {
      return this.taxes
        .filter((tax) => {
          return tax.is_for_expense
        })
        .map((tax) => {
          return {
            value: tax.tax_id,
            text: getDisplayTaxNameRate(getMasterDataText(tax.tax_name, this.$t), tax.amount),
          }
        })
    },
    fakeOrders() {
      return [
        {
          price: this.form.payment_amount,
          taxes: this.selectedTaxes,
        },
      ]
    },
    total () {
      const oders = this.getDataSetOrders(this.fakeOrders)
      return this.getTotal(oders)
    },
    taxResults () {
      const isGroupTaxName = false
      const oders = this.getDataSetOrders(this.fakeOrders)
      return this.getTaxesByOrders(oders, isGroupTaxName).map((tax) => {
        return {
          form_type: tax.form_type,
          taxRate: tax.amount,
          total: (() => {
            if (tax.amount <= -1) {
              return Math.abs(tax.total)
            }
            return tax.total
          })(),
          displayText: tax.displayText,
        }
      })
    },
  },
  methods: {
    ...mapActions([
      'insertExpense',
    ]),
    getDataSetOrders (orders) {
      const data = _.cloneDeep(orders)
      const newData = []
      // remove key, data we don't need
      for (const i in data) {
        const item = data[i]
        newData.push({
          item: null,
          description: null,
          sku_id: null,
          quantity: 1,
          price: item.price,
          discounts: [],
          taxes: item.taxes.map((tax) => ({
            name: tax.tax_name,
            type: tax.type,
            amount: tax.amount,
            form_type: tax.form_type,
            group_name: tax.group_name,
            is_display_fee_result: tax.is_display_fee_result,
            is_for_expense: tax.is_for_expense,
            tax_id: tax.tax_id,
          })),
        })
      }
      return newData
    },
    async onAddedVendor (value) {
      // show loading selectize
      this.form.loadingVendor = true

      // insert new vendor
      let res = await this.$store.dispatch('insertVendor', { name: value })

      if (res.success) {
        let vendor = res.data
        // update option value
        this.form.updateOptionVendor = {
          text: value,
          value: vendor.vendor_id,
          picked: true,
        }
        this.form.optionVendors.push({
          text: value,
          value: vendor.vendor_id,
        })
        // finish loading
        this.showFinish(this.$Progress)
        // hide loading selectize
        this.form.loadingVendor = false
      }
    },
    isValid () {
      if (this.form.pickedDescription == null) {
        return false
      } else {
        if (this.form.pickedDescription.trim().length == 0) {
          return false
        }
      }
      return true
    },
    async update (opt = {}) {
      this.isSubmitted = true
      this.form.trickDescriptionValidation++

      if (!this.isValid()) {
        return
      }

      const orders = this.getDataSetOrders(this.fakeOrders)
      const taxes = orders[0].taxes
      const vendorInfo = this.getVendorById(this.form.pickedVendorId)

      const dataSet = {
        'ex_id': this.expense.ex_id,
        'status': 'padding',
        'description': this.form.pickedDescription,
        'expense_type': this.form.expense_type,
        'created_at': this.form.created_at ? this.form.created_at.toISOString() : this.moment().toISOString(),
        'paid_by': this.form.paid_by,
        'payment': {
          'price': parseFloat(this.form.payment_amount),
          'sub': this.total.untaxed,
          'tax': this.total.taxes.all,
          'total': this.total.payment,
          'amount': this.total.grand,
        },
        'note': this.form.note.trim() ? this.form.note.trim() : null,
        'vendor_id': this.form.pickedVendorId,
        'taxes': taxes,
        'report': {
          'sub_total': this.total.untaxed,
          'tax_total': this.total.taxes.all,
          'grand_total': this.total.grand,
          'category_id': null,
          'category_name': this.form.expense_type,
          'vendor_id': this.form.pickedVendorId,
          'vendor_name': vendorInfo ? vendorInfo.vendor_name : null,
        },
      }

      // update vendor
      const dataSetVendorUpdate = this.getDataSetPartnerUpdate('vendor', this.form.pickedVendorId, this.form.vendor, this.vendors)
      if (dataSetVendorUpdate !== null) {
        await this.$store.dispatch('updateVendor', dataSetVendorUpdate)
        await this.$store.dispatch('getVendors')
      }

      const res = await this.$store.dispatch('updateExpense', dataSet)

      if (res.success) {
        // get
        await this.$store.dispatch('getExpense', {
          ex_id: this.expense.ex_id,
        })
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.expense.ex_code }),
          color: 'success',
          icon: 'cloud',
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      setTimeout(() => {
        that.ready = true
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }, 100)
    },
    setData () {
      let expense = this.expense
      let form = this.form

      form.defaultDescription = expense.description
      form.created_at = this.moment(expense.created_at)._d,
      form.paid_by = expense.paid_by,
      form.payment_amount = this.setToCustomDigitsNumber(expense.payment.price),
      form.note = expense.note ? expense.note : ''
      this.form.expense_type = expense.expense_type
      this.form.taxIds = expense.taxes.map((tax) => tax.tax_id)

      if (this.expense.ven_id) {
        this.form.defaultVendorId = this.expense.ven_id
      } else {
        this.form.defaultVendorId = null
      }

      // set originalForm
      this.originalForm = _.cloneDeep(this.form)
    },
    openConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    async del () {
      let data = {
        ex_id: this.expense.ex_id,
      }

      // delete reference payments
      this.expense.reference.payments.map(async (payment) => {
        let data = {
          'pe_id': payment.pe_id,
          'reference': {
            'ex_id': this.expense.ex_id,
          },
        }
        let res = await this.$store.dispatch('deletePayment', data)
      })

      // delete expense
      let res = await this.$store.dispatch('deleteExpense', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.expense.ex_code }),
          color: 'danger',
          icon: 'delete',
        })
        // finish loading
        this.showFinish(this.$Progress)
        // close modal
        this.closeConfirmdeleteModal()
        // go to
        return this.$router.push({ name: 'ExpensesClaimAll' })
      }
    },
    async updateExpenseStatus (data) {
      this.isSubmitted = true
      let res = await this.$store.dispatch('updateExpenseStatus', { ex_id: data.ex_id, status: data.status })
      this.showFinish(this.$Progress)
      this.isSubmitted = false
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    descriptionLists: function (after, before) {
      let lists = after
      this.form.optionCustomers = []
      for (let i in lists) {
        let item = lists[i]
        this.form.optionDescriptions.push({
          text: item.description,
          value: item.description,
        })
      }
    },
    vendors: function (after, before) {
      this.form.optionVendors = []
      for (let i in after) {
        let vendor = after[i]
        this.form.optionVendors.push({
          text: vendor.vendor_name,
          value: vendor.vendor_id,
        })
      }
    },
    'form.pickedVendorId': {
      handler: function (after) {
        let vendor_id = after
        let vendorInfo = this.getVendorById(vendor_id)

        this.form.vendor.address = null
        this.form.vendor.tax_id = null
        this.form.vendor.email = null
        this.form.vendor.tel = null

        if (vendorInfo) {
          this.form.vendor.address = vendorInfo.address
          this.form.vendor.tax_id = vendorInfo.tax_id
          this.form.vendor.email = this.getPartnerContact(vendorInfo.contacts).email
          this.form.vendor.tel = this.getPartnerContact(vendorInfo.contacts).tel
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    /**
     *  validation
     */
    if (!this.$route.query.ex_id) {
      return this.$router.push({ name: 'ExpensesClaimAll' })
    }
    const res = await this.$store.dispatch('getExpense', {
      ex_id: this.$route.query.ex_id,
    })
    if (!res.success) {
      return this.$router.push({ name: 'ExpensesClaimAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'ExpensesClaimAll' })
    }
    await Promise.all([
      this.$store.dispatch('getTaxes'),
      this.$store.dispatch('getVendors'),
      this.$store.dispatch('getExpenseDescriptionLists'),
    ])
    /**
     *  validation success
     */
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat

    // set data
    this.setData()
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.expenses.title'),
      current: {
        app_name: 'expenses',
        app_id: 6,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 0, [{
      'name': this.$route.query.ex_code,
      'router': {
        'name': 'ExpensesClaimEdit',
        'query': {
          ex_id: this.$route.query.ex_id,
          ex_code: this.$route.query.ex_code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 0,
      submenuAtIdx: 2,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#confirmdeleteModal')
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearExpense'])
  },
}
</script>

<style scoped>
  .scheduled {
    position: relative;
  }
  .scheduled .overlay {
    display: none;
  }
  .scheduled.disabled .overlay {
    position: absolute;
    width: -webkit-calc(100% - 30px);
  	width:    -moz-calc(100% - 30px);
  	width:         calc(100% - 30px);
    height: 38px;
    top: 32px;
    left: 15px;
    z-index: 1;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/expenses/ex/Edit.vue